"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.PsaResult = exports.PsaMeasured = exports.DreResult = exports.DreMeasured = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
var DreMeasured;
(function (DreMeasured) {
    DreMeasured["YES"] = "YES";
    DreMeasured["NO"] = "NO";
})(DreMeasured || (exports.DreMeasured = DreMeasured = {}));
var DreResult;
(function (DreResult) {
    DreResult["ABNORMAL"] = "ABNORMAL";
    DreResult["NORMAL"] = "NORMAL";
})(DreResult || (exports.DreResult = DreResult = {}));
var PsaMeasured;
(function (PsaMeasured) {
    PsaMeasured["YES"] = "YES";
    PsaMeasured["NO"] = "NO";
})(PsaMeasured || (exports.PsaMeasured = PsaMeasured = {}));
var PsaResult;
(function (PsaResult) {
    PsaResult["ABNORMAL"] = "ABNORMAL";
    PsaResult["NORMAL"] = "NORMAL";
})(PsaResult || (exports.PsaResult = PsaResult = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ltx.phaseI.consultations.urology.result.ABNORMAL",
        defaultMessage: "Igen"
    },
    [Result.NORMAL]: {
        id: "ltx.phaseI.consultations.urology.result.NORMAL",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
])
    .expiration(31104000)
    .interpretation({ vocab: "ltx", code: "urology_result" });
const dreMeasured = schema_1.Schema.enum([DreMeasured.YES, DreMeasured.NO]);
const dreResult = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../measured} === "YES"`), schema_1.Schema.enum([DreResult.ABNORMAL, DreResult.NORMAL])
    .interpretation({ vocab: "ltx", code: "digital_rectal_exam_result" })
    .tag({ vocab: "snomed", code: "410006001" }));
const dre = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ measured: dreMeasured, result: dreResult });
const psaMeasured = schema_1.Schema.enum([PsaMeasured.YES, PsaMeasured.NO]);
const psaResult = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../measured} === "YES"`), schema_1.Schema.enum([PsaResult.ABNORMAL, PsaResult.NORMAL])
    .interpretation({
    vocab: "ltx",
    code: "prostate_specific_antigen_result"
})
    .tag({ vocab: "snomed", code: "1030791000000100" })
    .tag({ vocab: "loinc", code: "53764-7" }));
const psa = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ measured: psaMeasured, result: psaResult });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, dre, psa })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "305729009" })
    .tag({ vocab: "loinc", code: "34851-6" });
